import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=9765c99e&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=9765c99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9765c99e",
  null
  
)

export default component.exports